import * as axios from 'axios';
import moment from 'moment';
import constant from '../constant';
import { setsessionStorage, setStorage } from '../utils';
import { getAuthHeader } from '../utils';

export const companyExist = (COMPANY_NAME) => {
    const url = `${process.env.REACT_APP_BASE_URL}/company-exist?COMPANY_NAME=${COMPANY_NAME}`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};


export const emailExist = (EMAIL) => {

    const url = `${process.env.REACT_APP_BASE_URL}/email-exist?EMAIL=${EMAIL}`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};

export const industryList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-industry-list`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};


export const recruiterRegister = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/register-recruiter`;
    return axios.post(url, model).then((res) => {
        if (res.data.status) {
            setStorage(constant.keys.token, res.data.result.token);
            setStorage(constant.keys.userDetails, res.data.result);
            setsessionStorage(constant.keys.token, res.data.result.token);
            setStorage(constant.keys.loggedIn, moment().format('X'));
            setStorage(constant.keys.remeber_me, true);
        }
        return res.data;
    })
};

export const ForgetPassword = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruiter-forget-password`;
    return axios.put(url, model).then((res) => {
        return res.data;
    })
};

export const resetPasswRecruiterUser = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruiter-reset-password`;
    return axios.put(url, model, model.header).then((res) => {
        return res.data;
    })
};

export const changePasswRecruiterUser = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruiter-change-password`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const login = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/auth/login`;
    return axios.post(url, model).then((res) => {
        if (res.data.status) {
            setStorage(constant.keys.token, res.data.result.accessToken);
            setStorage(constant.keys.userDetails, res.data.result.ud_data);
            setStorage(constant.keys.loggedIn, moment().format('X'));
        }

        return res.data;
    })
};


export const register = (model, step) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/auth/register/${step}`;
    return axios.post(url, model).then((res) => {
        if (step === 4) {
            if (res.data.status) {
                setStorage(constant.keys.token, res.data.result.accessToken);
                setStorage(constant.keys.userDetails, res.data.result.ud_data);
                setStorage(constant.keys.loggedIn, moment().format('X'));
            }
        }
        return res.data;
    })
};


export const resentRegistrationOtp = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/auth/resendOtp/register`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })
};







// export const verifyLoginOtp = (model) => {
//     const url = `${process.env.REACT_APP_BASE_URL}/recruiter-login-otp-verify`;
//     return axios.post(url, model).then((res) => {
//         if (res.data.status) {
//             setStorage(constant.keys.token, res.data.result.token);
//             setStorage(constant.keys.userDetails, res.data.result);
//             setsessionStorage(constant.keys.token, res.data.result.token);
//             setStorage(constant.keys.loggedIn, moment().format('X'));
//             setStorage(constant.keys.remeber_me, true);
//         }
//         return res.data;
//     })
// };
export const sendLoginOtp = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/login/otp-send`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })
};
export const verifyLoginOtp = (model) => {
    debugger
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/login/otp-verify`;
    return axios.post(url, model).then((res) => {
        if (res.data.status) {
            setStorage(constant.keys.token, res.data.result.token);
            setStorage(constant.keys.userDetails, res.data.result);
            // setsessionStorage(constant.keys.token, res.data.result.token);
            setStorage(constant.keys.loggedIn, moment().format('X'));
            setStorage(constant.keys.remeber_me, true);
        }
        return res.data;
    })
};


export const reSendOTP = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/resend-otp`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })
};


export const registerstepone = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/register-step-one`;
    return axios.post(url, model).then((res) => {
        return res.data;
    })
};

export const outplacement = (token, model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/outplacement`;
    const header = {
        headers: { Authorization: "Bearer " + token }
    };
    return axios.post(url, model, header).then((res) => {
        return res.data;
    })
};

export const FAQOurBlog = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/jzsh/blog/recent`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};

export const isATSEnabled = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/rzg-is-ats-enabled`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const onboard = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/rzg-onboard-candidate`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const AddNewCandidate = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/jsh-add-new-candidate`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const subUserCreate = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/sub-user`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const subUserById = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-sub-user-by-id`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const subUserUpdate = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/sub-user`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const subUserList = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/sub-user/${model.page}/${model.limit}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};
export const genderDropDown = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/jzsh/options/gender`;
    return axios.get(url).then((res) => {
        return res.data;
    })
}